import { ThemeData } from "../../types";

import { useTypedSelector } from ".";

export const useTheme = (): ThemeData =>
  useTypedSelector(state => state.setting.theme);
